import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD76z34fZaI2-B7NfIkw4Hnz9PgixBshJU",
  authDomain: "cca-gradebook.firebaseapp.com",
  projectId: "cca-gradebook",
  storageBucket: "cca-gradebook.firebasestorage.app",
  messagingSenderId: "417893131503",
  appId: "1:417893131503:web:17f84379ac91dd47a8271a"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

export { signInWithPopup, signOut };
